export default "__VITE_ASSET__0ZIpnuf9__"